import type { Course } from '@/types';
import { CourseStatus } from '@/types';

/**
 * Mock course catalog for AG Grid when VITE_USE_MOCKS=true (npm run dev:mock).
 * Rows mirror QA getCourses-style payloads (school NIDs, mixed subject areas, string credits from API coerced to number).
 */
export const MOCK_COURSE_CATALOG: Course[] = [
  {
    id: '7510_2',
    name: '3MLT RDG DEV 6-8',
    subjectArea: { name: 'test1', CSSCCourse: 0, SCEDSubject: 1 },
    credits: 2,
    grades: [9],
    status: CourseStatus.ACTIVE,
    schools: ['5500010DUS'],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: 'Untracked',
  },
  {
    id: '5502_2',
    name: '4PHYS ED 8TH',
    subjectArea: { name: '2', CSSCCourse: 0, SCEDSubject: 3 },
    credits: 2,
    grades: [9, 10],
    status: CourseStatus.ACTIVE,
    schools: ['5500010DUS'],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: 'Untracked',
  },
  {
    id: '6005_2',
    name: '5SCIENCE 8TH',
    subjectArea: { name: 'dajhbcdsjhbcjhdsbjhsdbfjdsbfhjsdb', CSSCCourse: 0, SCEDSubject: 3 },
    credits: 2,
    grades: [9],
    status: CourseStatus.ACTIVE,
    schools: ['5500010DUS'],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: 'Untracked',
  },
  {
    id: 'MA001',
    name: 'A3 test - Engineering Mathematics 1',
    subjectArea: { name: 'Power Engineering', CSSCCourse: 41, SCEDSubject: 21 },
    credits: 3,
    grades: [11, 12],
    status: CourseStatus.ACTIVE,
    schools: [],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: '',
  },
  {
    id: '11601.1',
    name: 'ALGEBRA 1asjhvasgdghasd asuvdas gduyas sdjasgdasg dyasg d',
    subjectArea: { name: 'test', CSSCCourse: 0, SCEDSubject: 5 },
    credits: 1,
    grades: [9, 10, 11],
    status: CourseStatus.ACTIVE,
    schools: ['5500010DUS'],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: 'Untracked',
  },
  {
    id: 'MATH101.3',
    name: 'Algebra HS',
    subjectArea: { name: 'Mathematics', CSSCCourse: 0, SCEDSubject: 21 },
    credits: 1,
    grades: [6, 7, 8, 9, 10, 11, 12],
    status: CourseStatus.ACTIVE,
    schools: ['5500010DUS'],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: 'Untracked',
  },
  {
    id: 'ALG001.7',
    name: 'Algebra II',
    subjectArea: { name: 'Math', CSSCCourse: 27, SCEDSubject: 2 },
    credits: 1,
    grades: [6, 7, 8, 9, 10, 11, 12],
    status: CourseStatus.ACTIVE,
    schools: [
      '891545USPU',
      '892552USPU',
      '892560USPU',
      '889761USPU',
      '892567USPU',
      '890090USPU',
      '55001USPU',
      '889867USPU',
      '55004USPU',
      '55003USPU',
      '55002USPU',
      '891566USPU',
      '891571USPU',
      '892559USPU',
      '892561USPU',
      '892562USPU',
      '892563USPU',
      '892863USPU',
      '892878USPU',
      '892879USPU',
      '889902USPU',
    ],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: 'College level',
  },
  {
    id: 'CALC',
    name: "Andrew Lane's Calculus Course",
    subjectArea: { name: 'Mathematics by Brian', CSSCCourse: 27, SCEDSubject: 2 },
    credits: 1,
    grades: [9, 10, 11, 12],
    status: CourseStatus.ACTIVE,
    schools: [
      '889727USPR',
      '891545USPU',
      '892552USPU',
      '892560USPU',
      '893367USPU',
      '889761USPU',
      '893334USPU',
      '892567USPU',
      '890018USPR',
      '890090USPU',
      '55001USPU',
      '889867USPU',
      '55004USPU',
      '55003USPU',
      '55002USPU',
      '891566USPU',
      '891571USPU',
      '891467USPR',
      '892559USPU',
      '892561USPU',
      '892562USPU',
      '892563USPU',
      '892863USPU',
      '892878USPU',
      '892879USPU',
      '889902USPU',
    ],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: '',
  },
  {
    id: 'HIS320',
    name: 'AP Art History',
    subjectArea: { name: 'History', CSSCCourse: 0, SCEDSubject: 4 },
    credits: 0.5,
    grades: [11, 12],
    status: CourseStatus.ACTIVE,
    schools: ['blue1hs'],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: 'Untracked',
  },
  {
    id: '39012',
    name: 'AP ENGLISH',
    subjectArea: { name: 'p1033', CSSCCourse: 0, SCEDSubject: 19 },
    credits: 1,
    grades: [11],
    status: CourseStatus.ACTIVE,
    schools: ['5500010DUS'],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: 'Untracked',
  },
  {
    id: 'HIS210',
    name: 'AP European History',
    subjectArea: { name: 'History', CSSCCourse: 0, SCEDSubject: 4 },
    credits: 1,
    grades: [10, 11, 12],
    status: CourseStatus.ACTIVE,
    schools: ['blue1hs'],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: 'Untracked',
  },
  {
    id: 'HIS230',
    name: 'AP Government',
    subjectArea: { name: 'History', CSSCCourse: 0, SCEDSubject: 4 },
    credits: 1,
    grades: [11, 12],
    status: CourseStatus.ACTIVE,
    schools: ['blue1hs'],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: 'Untracked',
  },
  {
    id: 'HIS110',
    name: 'AP Human Geography',
    subjectArea: { name: 'History', CSSCCourse: 0, SCEDSubject: 4 },
    credits: 1,
    grades: [9, 10, 11, 12],
    status: CourseStatus.ACTIVE,
    schools: ['blue1hs'],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: 'Untracked',
  },
  {
    id: 'HIS310',
    name: 'AP Psychology',
    subjectArea: { name: 'History', CSSCCourse: 0, SCEDSubject: 4 },
    credits: 0.5,
    grades: [11, 12],
    status: CourseStatus.ACTIVE,
    schools: ['blue1hs'],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: 'Untracked',
  },
  {
    id: 'HIS220',
    name: 'AP US History',
    subjectArea: { name: 'History', CSSCCourse: 0, SCEDSubject: 4 },
    credits: 1,
    grades: [10, 11, 12],
    status: CourseStatus.ACTIVE,
    schools: ['blue1hs'],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: 'Untracked',
  },
  {
    id: 'HIS120',
    name: 'AP World History',
    subjectArea: { name: 'History', CSSCCourse: 0, SCEDSubject: 4 },
    credits: 1,
    grades: [10, 11, 12],
    status: CourseStatus.ACTIVE,
    schools: ['blue1hs'],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: 'Untracked',
  },
  {
    id: '67567523',
    name: 'asvjhdbj',
    subjectArea: { name: 'English', CSSCCourse: 0, SCEDSubject: 1 },
    credits: 23,
    grades: [6, 7],
    status: CourseStatus.ACTIVE,
    schools: [],
    cteCourse: false,
    repeatable: true,
    instructionalLevel: '',
  },
  {
    id: '900123123',
    name: 'Athri Course - M1',
    subjectArea: { name: '1010', CSSCCourse: 0, SCEDSubject: 10 },
    credits: 4,
    grades: [],
    status: CourseStatus.ACTIVE,
    schools: ['5500010DUS'],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: 'Untracked',
  },
  {
    id: '900123124',
    name: 'Athri Course - M2',
    subjectArea: { name: '1010', CSSCCourse: 0, SCEDSubject: 10 },
    credits: 3,
    grades: [],
    status: CourseStatus.ACTIVE,
    schools: ['5500010DUS'],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: 'Untracked',
  },
  {
    id: '90012125',
    name: 'Athri Course - Trigonometry',
    subjectArea: { name: '1010', CSSCCourse: 0, SCEDSubject: 10 },
    credits: 4,
    grades: [],
    status: CourseStatus.ACTIVE,
    schools: ['5500010DUS'],
    cteCourse: false,
    repeatable: false,
    instructionalLevel: 'Untracked',
  },
];
